// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"74fe64c3","56":"ae156be3","175":"eb4c6248","311":"1c857621","336":"66c72969","380":"9147a373","384":"5fe23ef2","417":"1b6479f4","665":"340848fc","895":"f7614c64","912":"7d7b15a2"}[chunkId] + ".chunk.js";
};